import { getApi, postApi, putApi } from "../../common/http-clients.jsx";

const apiUrl = process.env.REACT_APP_API_URL;

export const getAssignmentDetailsApi = async (id) => {
  try {
    const response = await getApi(`${apiUrl}vehicle_assignment/view/${id}`);
    return response;
  } catch (err) {
    return err.response || { data: { success: false, message: err.message } };
  }
};

export const updateAssignmentStatusApi = async (id, data) => {
  try {
    const response = await putApi(`${apiUrl}vehicle_assignment/statusupdate/${id}`, data);
    return response;
  } catch (err) {
    return err.response || { data: { success: false, message: err.message } };
  }
};

export const getVehicleDetailApi = async (id) => {
  try {
    const response = await getApi(`${apiUrl}get_vehicle_details/${id}`);
    return response;
  } catch (err) {
    return err.response || { data: { success: false, message: err.message } };
  }
};

export const getVehicleAssignmentEditApi = async (id) => {
  try {
    const response = await getApi(`${apiUrl}vehicle_assignment/edit/${id}`);
    return response;
  } catch (err) {
    return err.response || { data: { success: false, message: err.message } };
  }
};

export const createAssignmentApi = async (body) => {
  try {
    const response = await postApi(`${apiUrl}vehicle_assignment`, body);
    return response;
  } catch (err) {
    return err.response || { data: { success: false, message: err.message } };
  }
};

export const updateAssignmentApi = async (body, id) => {
  try {
    const response = await putApi(`${apiUrl}vehicle_assignment/${id}`, body);
    return response;
  } catch (err) {
    return err.response || { data: { success: false, message: err.message } };
  }
};
